import './Header.css';
import { FC } from 'react';

const Header: FC = () => {
  return (
    <header className="header" aria-label="портфолио"></header>
  );
}

export default Header;
